module.exports = __webpack_public_path__ + "img/img_bg3_news.0bcd81c4.png";